export const TYPES = {
  SELECT_ROSTER_LIST_SUCCESS: "roster/SELECT_ROSTER_LIST_SUCCESS",
  SELECT_LOCK_ROSTER_LIST_SUCCESS: "roster/SELECT_LOCK_ROSTER_LIST_SUCCESS",
  SET_PREVIOUS_ROSTER_SUCCESS: "roster/SET_PREVIOUS_ROSTER_SUCCESS",
};
